import * as API from '../api'

export const FETCHING_CABINET_PRODUCTS = 'FETCHING_CABINET_PRODUCTS'
export const FETCH_CABINET_PRODUCTS = 'FETCH_CABINET_PRODUCTS'
export const FETCH_CABINET_PRODUCTS_ERROR = 'FETCH_CABINET_PRODUCTS_ERROR'

export const fetchCabinetProducts = (id) => {
  return dispatch => {
    dispatch({
      type: FETCHING_CABINET_PRODUCTS
    })

    return API.cabinetProducts
      .getCabinetProducts(id)
      .then(response => {
        const { data } = response
        dispatch({
          type: FETCH_CABINET_PRODUCTS,
          cabinet: data
        })
      })
      .catch(err => {
        dispatch({
          type: FETCH_CABINET_PRODUCTS_ERROR
        })
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/cabinetProducts.js